import "./Tile";

/** @namespace GIS.Map.Layer */
NS("GIS.Map.Layer");
/**
 * @class
 */
GIS.Map.Layer.OSM = Class(GIS.Map.Layer.Tile, {
    title: "OpenStreetMap Tiles",
    attributions: ["Картографические данные © OpenStreetMap, " + moment().format('YYYY')],
    maxZoom: 20,
    projection: 'EPSG:3857',
    url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    /** @inheritDoc */
    initialize()
    {
        this.ParentCall();
        this.name = "GIS.Map.Layer.OSM:" + uuid.v4();
    }
});
